import { get, includes, lowerCase, upperCase } from "lodash"
import getSymbolFromCurrency from "currency-symbol-map"
import { getLocation } from "../apis"
import { setStoredLatLng } from '../v2_actions/auth'

let countries = require("country-data").countries
const publicIp = require("public-ip")

const defaultCountryLocations = {
    za: { lat: -33.918861, lng: 18.4233 },
    au: { lat: -33.865143, lng: 151.2099 },
    us: { lat: 51.509865, lng: -0.118092 }
} // london for some reason


const DEFAULT_COUNTRY_CODE = "au"
const VALID_COUNTRY_CODES = ["za", "au", "us"]
const URLS_WITHOUT_COUNTRY_CODE = ["corporate"]
const HOME_URL = "/photographer/howitworks"

// export const ensureCountryCodeIsValid = () => {
//     return async(dispatch, getState) => {

//         const state = getState()
//         const urlCountryCode = getCountryCodeFromUrl()
//         const userCountryCode = getUserStoredCountryCode()

//         const userCountryCodeIsValid = userCountryCode && includes(VALID_COUNTRY_CODES, lowerCase(userCountryCode))

//         let bestCountryCode = null
//         let bestCurrencyCode = null
//         let bestCurrencySymbol = null

//         const onSetCountryCode = (country_code) => {
//             storeCountryDetails({country_code: bestCountryCode, bestCurrencyCode, bestCurrencySymbol})
//         }

//         if ( userCountryCodeIsValid ) {

//             if ( userCountryCode !== urlCountryCode ) {
//                 // The user knows where he wants to be, but he's not there

//                 const urlCountryCodeIsValid = includes(VALID_COUNTRY_CODES, lowerCase(urlCountryCode))
//                 if ( urlCountryCodeIsValid ) {
//                     // Allow the url overriding the customer's stored location
//                     bestCountryCode = urlCountryCode
//                 } else {
//                     // Url is an invalid country, so go to the user's country
//                     bestCountryCode = userCountryCode
//                 }

//             } else {
//                 bestCountryCode = urlCountryCode
//             }

//             const { currency_code, currency_symbol } = getCountryDetails(bestCountryCode)
//             bestCurrencyCode = currency_code
//             bestCurrencySymbol = currency_symbol

//             onSetCountryCode({country_code: bestCountryCode, bestCurrencyCode, bestCurrencySymbol})

//         } else {

//             // No country code in the url, so make a guess
//             guessCountryCode( ({country_code, position}) => {
//                 const { currency_code, currency_symbol } = getCountryDetails(country_code)
//                 bestCurrencyCode = currency_code
//                 bestCurrencySymbol = currency_symbol
//                 bestCountryCode = country_code

//                 onSetCountryCode({country_code: bestCountryCode, bestCurrencyCode, bestCurrencySymbol})
//             })
//         }


//         // ensure the ip address-based position is up-to-date as well, because it's independant of the country code
//         let { lat, lng } = getStoredLatLng()

//         if ( ! lat || ! lng ) {
//             guessCountryCode(({position}) => {
//                 storeCountryDetails({position})
//                 dispatch(setMapCenter(position))
//             })
//         }

//         const mapCenter = getMapCenter(state)
//         if ( get(mapCenter, "lat") !== lat ||
//              get(mapCenter, "lng") !== lng ) {
//             dispatch(setMapCenter({lat, lng}))
//         }

//     }

// }

// const getCountryCodeFromUrl = () => {
//     const urlCountryCode = lowerCase(get(split(window.location.pathname, "/"), 1))
//     if ( ! includes(VALID_COUNTRY_CODES, urlCountryCode) && includes(URLS_WITHOUT_COUNTRY_CODE, urlCountryCode)) {
//         return null
//     }
//     return lowerCase(urlCountryCode)
// }

export const guessCountryCode = (onGuessed) => {

    publicIp.v4().then((ip_address) => {
        getLocation(ip_address)
            .then((response) => {
                const data = response.data
                let country_code = lowerCase(data.countryCode)
                const pos_array = data.location
                const position = { lat: pos_array[0], lng: pos_array[1] }

                if (!includes(VALID_COUNTRY_CODES, country_code)) {
                    country_code = DEFAULT_COUNTRY_CODE
                }

                onGuessed({ country_code, position })

                // Try the best values we can get by asking the user,
                // doesn't give us the country code so we still us the ip guesser first
                if (navigator.geolocation) {
                    navigator.geolocation.getCurrentPosition((coords) => {
                        onGuessed({
                            country_code, position: {
                                lat: coords.latitude,
                                lng: coords.longitude
                            }
                        })
                    })
                }

            })
            .catch((data, status) => {
                onGuessed({
                    country_code: DEFAULT_COUNTRY_CODE,
                    position: get(defaultCountryLocations, DEFAULT_COUNTRY_CODE)
                })
            })
    })
        .catch((data, status) => {
            onGuessed({
                country_code: DEFAULT_COUNTRY_CODE,
                position: get(defaultCountryLocations, DEFAULT_COUNTRY_CODE)
            })
        })
}

export const getCountryDetails = (country_code) => {
    const currency_code = get(countries, [upperCase(country_code), "currencies", 0])
    return {
        currency_code,
        currency_symbol: getSymbolFromCurrency(currency_code),
        position: get(defaultCountryLocations, country_code)
    }
}

// export const detectCountryCode = async () => {
//     const ip_address = await publicIp.v4()
//     return getLocation(ip_address)
//         .then((response) => {
//             const data = response.data
//             let country_code = data.countryCode
//             let pos_array = data.location
//             let country_codes = ["ZA", "AU", "US"]
//             let flag = country_codes.includes(country_code)
//             if (!flag) country_code = "US"
//             const currency_code = get(countries, [upperCase(country_code), "currencies", 0])
//             const currency_symbol = getSymbolFromCurrency(currency_code)
//             const pos = { lat: pos_array[0], lng: pos_array[1] }

//             ensureUrlReflectsUsersCountryCode()
//             const position = getCountryLocation(country_code)
//             setLocalStorage(country_code, currency_code, currency_symbol, position)

//             return lowerCase(country_code)
//         })
//         .catch((data, status) => {
//             const country_code = "us"
//             const currency_code = "USD"
//             const currency_symbol = "$"
//             const position = LocationLondon
//             setLocalStorage(country_code, currency_code, currency_symbol, position)
//             return country_code
//         })
// }

// export const getCountryLocation = (country_code) => {
//     const upcaseCountryCode = upperCase(country_code)
//     let position = null
//     if (country_code === "za") {
//         position = LocationCapeTown
//     } else if (country_code === "au") {
//         position = LocationSydney
//     } else {
//         position = LocationLondon
//     }
// }

const storeCountryDetails = ({ country_code, currency_code, currency_symbol, position }) => {
    if (country_code) {
        window.localStorage.setItem("country", country_code)
    }
    if (currency_code) {
        window.localStorage.setItem("currency_code", currency_code)
    }
    if (currency_symbol) {
        window.localStorage.setItem("currency", currency_symbol)
    }
    if (position && parseFloat(position.lat) && parseFloat(position.lng)) {
        setStoredLatLng(position)
    }
}

export const countrycodeToNameConverter = (name) => {
    let countryName = new Intl.DisplayNames(['en'], { type: 'region' });
    console.log(countryName.of(name))
    return countryName.of(name);
}
